module.exports = __webpack_public_path__ + "img/product_80.651ff49.webp";